import React, { useState, useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import {
  Build,
  Person,
  Assignment,
  PermContactCalendar,
  VerifiedUser,
  AccessTime,


  
  Dashboard,
  Settings,
} from "@material-ui/icons/";
// core components
import Navbar from "components/Navbars/Navbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";
import styles from "assets/jss/material-dashboard-react/layouts/adminStyle.js";

import bgImage from "assets/img/sidebar-2.jpg";
import logo from "assets/img/logo2.png";

import Employee from "views/HR/Employee.js";
import Department from "views/HR/Department.js";
import Holiday from "views/HR/Holiday";
import UserRequest from "views/HR/UserRequest.js";
import TeamGroup from "views/HR/TeamGroup";
import HRDashboard from "views/HR/HRDashboard.js";

// ระบบลงเวลาปฏิบัติราชการ
import AttendanceRequest from "views/HR/Attendance/Request.js";
import MyAttendance from "views/HR/Attendance/MyAttendance.js";
import MyApproveAttendance from "views/HR/Attendance/MyApprove.js";
import HRAttendance from "views/HR/Attendance/HRAttendance.js";
import AttendanceSetting from "views/HR/Attendance/Setting.js";
import HotelIcon from "@material-ui/icons/Hotel";
import DormitoryStaffManagement from "views/Dormitory/DormitoryStaffManagement.js";

let ps;

const useStyles = makeStyles(styles);

export default function HR({ ...rest }) {
  // styles
  const classes = useStyles();
  const mainPanel = React.createRef();
  const [image, setImage] = React.useState(bgImage);
  const [color, setColor] = React.useState("blue");
  const [fixedClasses, setFixedClasses] = React.useState("dropdown show");
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isHR, setIsHR] = useState(false);

  useEffect(() => {
    try {
      const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
      const _isHR =
        currentUser?.userDepartment?.some(
          (u) =>
            u.departmentKey === 105 ||
            u.departmentKey === 108 ||
            (u.departmentKey === 143 && u.userLevelKey === 3)
        ) || currentUser?.userName === "madarakung";
      setIsHR(_isHR);
    } catch (e) {
      console.log(e);
    }
  }, []);

  const routes = [
    {
      name: "แดชบอร์ดบุคลากร",
      icon: Dashboard,
      component: HRDashboard,
      layout: "/hr",
      path: "/dashboard",
    },
    {
      name: "ระบบลงเวลาปฏิบัติราชการ",
      icon: Assignment,
      component: AttendanceRequest,
      layout: "/hr",
      path: "/attendance/request",
    },
    {
      name: "ประวัติการลงเวลาของฉัน",
      icon: PermContactCalendar,
      component: MyAttendance,
      layout: "/hr",
      path: "/attendance/me",
    },
    {
      name: "รายการรอรับรอง / อนุมัติ",
      icon: VerifiedUser,
      component: MyApproveAttendance,
      layout: "/hr",
      path: "/attendance/myapprove",
    },
    {
      name: "HR ตรวจสอบลงเวลา",
      icon: AccessTime,
      component: HRAttendance,
      layout: "/hr",
      path: "/attendance/hr",
      hidden: !isHR,
    },
    {
      name: "ตั้งค่าประเภทการลงเวลา",
      icon: Settings,
      component: AttendanceSetting,
      layout: "/hr",
      path: "/attendance/setting",
      hidden: !isHR,
    },
    {
      name: "โครงสร้าง",
      icon: Build,
      component: Department,
      layout: "/hr",
      path: "/department",
      hidden: !isHR,
    },
    {
      name: "ข้อมูลเจ้าหน้าที่",
      icon: Build,
      component: Employee,
      layout: "/hr",
      path: "/index",
      hidden: !isHR,
    },
    {
      name: "จัดการวันหยุด",
      icon: Build,
      component: Holiday,
      layout: "/hr",
      path: "/holiday",
      hidden: !isHR,
    },
    {
      name: "แบบคำขอรหัสเข้าใช้งาน",
      icon: Person,
      component: UserRequest,
      layout: "/hr",
      path: "/user",
      hidden: !isHR,
    },
    {
      name: "จัดการคณะกรรม",
      icon: Person,
      component: TeamGroup,
      layout: "/hr",
      path: "/teamgroup",
      hidden: !isHR,
    },
    {
      name: "ระบบหอพัก/ห้องพักบุคลากร",
      icon: HotelIcon,
      component: DormitoryStaffManagement,
      layout: "/hr",
      path: "/dormitory",
      hidden: !isHR,
    },
  ];

  const switchRoutes = (
    <Switch>
      <Route path="/hr/dormitory" component={DormitoryStaffManagement} />
      <Route path="/hr/teamgroup/:TeamGroupKey" component={TeamGroup} />
      <Route path="/hr/attendance/request/:id" component={AttendanceRequest} />
      <Route path="/hr/attendance/setting" component={AttendanceSetting} />
      <Route path="/hr/dashboard" component={HRDashboard} />
      <Route exact path="/hr" component={HRDashboard} />
      {routes
        .filter((p) => p.hidden == null || p.hidden === false)
        .map((prop, key) => (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        ))}
      <Redirect from="/hr" to="/hr/dashboard" />
    </Switch>
  );

  const handleImageClick = (image) => {
    setImage(image);
  };
  const handleColorClick = (color) => {
    setColor(color);
  };
  const handleFixedClick = () => {
    if (fixedClasses === "dropdown") {
      setFixedClasses("dropdown show");
    } else {
      setFixedClasses("dropdown");
    }
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/admin/maps";
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };

  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);

  return (
    <div className={classes.wrapper}>
      <Sidebar
        routes={routes}
        logoText={"ทรัพยากรบุคคล"}
        logo={logo}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      <div className={classes.mainPanel} ref={mainPanel}>
        <Navbar routes={routes} handleDrawerToggle={handleDrawerToggle} {...rest} />
        {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
        {getRoute() ? ( 
          <div className={classes.content}>
            <div className={classes.container}>{switchRoutes}</div>
          </div>
        ) : (
          <div className={classes.map}>{switchRoutes}</div>
        )}
        {getRoute() ? <Footer /> : null}
      </div>
    </div>
  );
}
